import React, { useMemo, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStatus, useToken } from '../../../utils'
import { useOfferList, useContractList, useSettlements } from '../../../hooks'
import styles from './HomeStatsCards.module.scss'

/**
 * 홈 화면용 제안/계약/입금 개수 카드
 * - 새로운 제안: 받은 제안 중 확인 안 한 것만 (is_visited !== true, 내가 보낸 건 제외)
 * - 계약: 진행 중인 계약 (대기 + 체결)
 * - 입금: 입금대기 건수
 */
export const HomeStatsCards = () => {
	const navigate = useNavigate()
	const [auth] = useAuthStatus()
	const token = useToken()
	const userId = auth?.user?.id

	const { data: offers = [] } = useOfferList(token, !!userId)
	const { data: contracts = [] } = useContractList()
	const { data: settlements = [] } = useSettlements()

	// 받은 데이터 구조 확인용 (디버깅 후 제거)
	useEffect(() => {
		if (offers?.length) {
			console.log('[HomeStatsCards] offers 받은 데이터:', offers)
			console.log(
				'[HomeStatsCards] 첫 번째 항목 키 목록:',
				offers[0] ? Object.keys(offers[0]) : [],
			)
			console.log('[HomeStatsCards] 첫 번째 항목 is_visited:', offers[0]?.is_visited)
		}
	}, [offers])

	const { offerCount, contractCount, depositCount } = useMemo(() => {
		// 새로운 제안: 받은 제안 중 확인 안 한 것만 (내가 보낸 제안은 제외, is_visited 없으면 미확인으로 간주)
		const unreadReceived = (offers || []).filter(
			(item) =>
				item &&
				item.target_user_id === userId &&
				item.is_visited !== true &&
				item.offer_status !== 'REJECTED' &&
				item.offer_status !== 'REJECT' &&
				item.offer_status !== 'CANCEL' &&
				item.offer_status !== 'OUTDATED' &&
				item.offer_status !== 'CONTRACT_PROPOSED',
		)
		const offerCount = unreadReceived.length

		// 계약 제안: 아직 체결 전이라 내가 액션을 취해야 하는 계약 (PRE, PRO_ACCEPTED)
		const pendingContracts = (contracts || []).filter(
			(item) => item?.contract_status === 'PRE' || item?.contract_status === 'PRO_ACCEPTED',
		)
		const contractCount = pendingContracts.length

		const depositCount = (settlements || []).filter(
			(item) => item?.paymentStatus === 'WAITING_FOR_PAYMENT',
		).length

		return { offerCount, contractCount, depositCount }
	}, [offers, contracts, settlements, userId])

	const cards = [
		{ label: '새로운 제안', value: offerCount, path: '/offers' },
		{ label: '계약 제안', value: contractCount, path: '/contracts' },
		{ label: '입금대기', value: depositCount, path: '/settlements' },
	]

	return (
		<div className={styles.wrapper}>
			{cards.map((card) => (
				<button
					key={card.label}
					type="button"
					className={styles.card}
					onClick={() => navigate(card.path)}>
					<span className={styles.label}>{card.label}</span>
					<span className={styles.value}>{card.value}</span>
				</button>
			))}
		</div>
	)
}
